import type { RailMaintenanceTranslations } from "../interfaces/railMaintenance";

export const railMaintenanceTranslations: RailMaintenanceTranslations = {
  badge: "Under maintenance",
  send_title: "{{country}}: transfers under maintenance",
  send_text:
    "We expect them back soon. If you have an urgent transfer, message us on WhatsApp and we will process it another way.",
  send_whatsapp_message: "Hi, I have an urgent transfer. Destination: {{country}}.",
  receive_title: "{{country}}: deposits under maintenance",
  receive_text:
    "We expect them back soon. If you need to receive a payment urgently, message us on WhatsApp and we will help you.",
  receive_whatsapp_message: "Hi, I need to receive an urgent payment. Country: {{country}}.",
  convert_title: "{{currency}}: transfers under maintenance",
  convert_text:
    "You can convert into {{currency}}. To send that balance you need to talk to support on WhatsApp at {{phone}}; it may take a little longer than usual.",
  convert_whatsapp_message: "Hi, I need to send a balance in {{currency}}.",
  buy_title: "{{asset}} purchases under maintenance",
  buy_text:
    "We expect them back soon. If you need to buy urgently, message us on WhatsApp and we will help you.",
  buy_whatsapp_message: "Hi, I need to buy {{asset}} urgently.",
  sell_title: "{{asset}} sales under maintenance",
  sell_text:
    "We expect them back soon. If you need to sell urgently, message us on WhatsApp and we will help you.",
  sell_whatsapp_message: "Hi, I need to sell {{asset}} urgently.",
  card_top_up_title: "Top-ups from pesos under maintenance",
  card_top_up_text:
    "We expect them back soon. You can load the card another way or, if it is urgent, message us on WhatsApp.",
  card_top_up_whatsapp_message: "Hi, I need to load my card from pesos urgently.",
  help_line: "Need help? Message us at {{phone}}.",
  whatsapp_cta: "Message us on WhatsApp",
};
